export default __webpack_public_path__ + "static/media/graduation.d72602f7.png";